module.exports = __webpack_public_path__ + "static/media/SarahSwitek_07_EnergyLevel_2.0ec7fbcb.mp3";